import { Icon } from '@factorialco/deprecated-design-system'

import { Action } from 'modules/automations/store/models/Action'

interface Props {
  actionableType: string
  selected: boolean
}

export default function ({ actionableType, selected }: Props) {
  const icon = actionableType === Action.Types.branch ? 'filter' : 'arrow-right'
  const color = selected ? 'viridian1000' : 'grey600'

  return function IllustrationComponent() {
    return <Icon.Medium icon={icon} color={color} />
  }
}
